import _ from 'lodash';
import { Device } from 'types';

export const getIsDeviceOfflineFiltersForES = (): any => {
    const current_time = Date.now();

    // Script written in Painless as expected by elastic search
    // This script is used in the ES query to determine if a device is offline
    const painlessOfflineDeviceScript = `
    def last_reading_time = doc.containsKey('lastReading.time') ? doc['lastReading.time'].value : null;
    def r_int = doc.containsKey('r_int') ? doc['r_int'].value : null;
    def t_int = doc.containsKey('t_int') ? doc['t_int'].value : null;
    if (last_reading_time == null) { 
      return true; 
    } 
    if (r_int == null) { 
      r_int = 6 * 60 * 60; 
    } 
    if (t_int == null || t_int == -1) { 
      t_int = 24 * 60 * 60; 
    } 
    def max_interval_seconds = Math.max(t_int + 8 * r_int, t_int + 25 * 60 * 60);
    def max_interval_ms = max_interval_seconds * 1000;
    def next_reading_time = last_reading_time + max_interval_ms;
    def current_time = ${current_time}L;
    return next_reading_time < current_time;
    `.trim();

    // Generate the proper ES query filter array
    const query_filter_array = [
        {
            script: {
                script: {
                    inline: painlessOfflineDeviceScript,
                },
            },
        },
        {
            term: {
                status: 'deployed',
            },
        },
    ];

    return query_filter_array;
};

// Check if device is offline based on last reading time, the r_int field and the t_int field.
export const isLastReadingTimeOffline = (
    last_reading_time?: number,
    r_int?: number,
    t_int?: number
): boolean => {
    // If no last reading time, consider the device offline
    if (!last_reading_time) return true;

    // Default r_int if not present
    if (!r_int) r_int = 6 * 60 * 60;

    // Default t_int if not present
    if (!t_int || t_int === -1) t_int = 24 * 60 * 60;

    // To determine offline grace period, use the max between:
    // 1. t_int + 8 * r_int
    // 2. t_int + 25 hours
    const max_interval_seconds = Math.max(
        t_int + 8 * r_int,
        t_int + 25 * 60 * 60
    );

    // Convert to ms so we can add grace period to last reading time
    const max_interval_ms = max_interval_seconds * 1000;

    const next_reading_time = last_reading_time + max_interval_ms;

    const current_time = new Date().getTime();

    // If next reading time is less than current time, device failed to report in, consider it offline
    return next_reading_time < current_time;
};

export const isDeviceOffline = (device: Device): boolean => {
    const last_reading_time = _.get(device, 'lastReading.time');
    return isLastReadingTimeOffline(
        last_reading_time,
        device.r_int,
        device.t_int
    );
};
